import {Web} from "./letzbig/app/Web"
import {Register} from "./genes/Register"

Web.main()